import React from 'react';
import AssignmentsResultCultivate from './AssignmentsResultCultivate';

const AssignmentsResultCultivateContainer = () => <AssignmentsResultCultivate />;

export default AssignmentsResultCultivateContainer;
